import { useQuery } from 'src/shared/lib/useQuery';
import { getAuthOptions, getLogo, getDimensions, AuthOptions, Dimensions } from 'src/shared/lib/auth.utils';

interface AuthPageData {
  logo: string | null | undefined;
  dimensions: Dimensions | undefined;
  authOptions: AuthOptions | null | undefined;
  isLoading: boolean;
}

export function useAuthPageData(): AuthPageData {
  const { data: authOptions, isLoading: isLoadingAuth } = useQuery({
    queryKey: ['authOptions'],
    queryFn: getAuthOptions,
    staleTime: 1000 * 60 * 10,
  });

  const { data: logo, isLoading: isLoadingLogo } = useQuery({
    queryKey: ['orgLogo'],
    queryFn: getLogo,
    staleTime: 1000 * 60 * 10,
  });

  const { data: dimensions } = useQuery({
    queryKey: ['logoDimensions', logo],
    queryFn: async () => (await getDimensions(logo!)) ?? null,
    enabled: !!logo,
    staleTime: Infinity,
  });

  return {
    logo,
    dimensions: dimensions ?? undefined,
    authOptions,
    isLoading: isLoadingAuth || isLoadingLogo,
  };
}
